import { Stack, Title, useMantineTheme } from '@mantine/core'
import React, { useMemo } from 'react'

import classes from '@/components/Discover/Feed/MembersList.module.css'
import PodiumIcon from '@/components/PodiumIcon'
import { bronzeColor, silverColor } from '@/utils/utils'

interface ListNumberProps {
  index: number
  phase: 'nomination' | 'campaign' | 'voting' | 'results'
  isMobile: boolean | undefined
  fullWidth?: boolean
}

const ListNumber: React.FC<ListNumberProps> = ({ isMobile, index, phase, fullWidth = false }) => {
  const theme = useMantineTheme()
  const results = useMemo(() => phase === 'results', [phase])

  return (
    <Stack
      className={classes.memberNoHover}
      style={{
        width: fullWidth ? '100%' : isMobile ? '30px' : '50px',
        alignItems: 'center',
        justifyContent: 'center',
        borderColor:
          results && index === 0
            ? theme.colors.barChartYellow[0]
            : results && index === 1
              ? silverColor
              : results && index === 2
                ? bronzeColor
                : '',
      }}
    >
      {results ? <PodiumIcon index={index} /> : <Title order={5}>{index + 1}.</Title>}
    </Stack>
  )
}
export default ListNumber
